import { client } from "../../utils";

export const fetchYearOfActionPage = () => dispatch => {
  client.getSingle("year_of_action").then(res => {
    dispatch({
      type: "FETCH_YEAR_OF_ACTION_PAGE",
      payload: res
    });
  });
};

export const fetchConferencePage = () => dispatch => {
  client.getSingle("conference").then(res => {
    dispatch({
      type: "FETCH_CONFERENCE_PAGE",
      payload: res
    });
  });
};

export const fetchHomePage = () => dispatch => {
  client.getSingle("home").then(res => {
    if (res) {
      dispatch({
        type: "FETCH_HOME_PAGE",
        payload: res
      });
    } else {
      dispatch({
        type: "FETCH_HOME_PAGE_FAILED"
      });
    }
  });
};

export const fetchWhatWeDoPage = () => dispatch => {
  client.getSingle("what_we_do").then(res => {
    dispatch({
      type: "FETCH_WHAT_WE_DO_PAGE",
      payload: res
    });
  });
};

export const fetchResourcePage = () => dispatch => {
  client.getSingle("resource_page").then(res => {
    dispatch({
      type: "FETCH_RESOURCE_PAGE",
      payload: res
    });
  });
};


// WEBPACK FOOTER //
// ./src/store/actions/singlePageActions.js